/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Special group code for marketing purposes.   (VMP: affinityGroupCode)   (german: Gruppenzugehörigkeit)   (bipro-produktmodell::STE_Kondition)     * `EmployeeOfVerti`   - german: Mitarbeiter von Verti   * `EmployeeOfAgent`   - german: Mitarbeiter des Vermittlers
 */
export const AffinityGroup = {
  EmployeeOfVerti: 'EmployeeOfVerti',
  EmployeeOfAgent: 'EmployeeOfAgent',
} as const;
export type AffinityGroup = (typeof AffinityGroup)[keyof typeof AffinityGroup];
